import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { OccEndpointsService } from '@spartacus/core';
import { KN_BR_CUSTOMERS } from 'src/constants/api.endpoints.constant';
import { CustomerSearchForm } from 'src/feature-libs/kn-br-user/kn-br-account/root/model/customer.model';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class KnBrCustomerAdapter {
  constructor(private endPointService: OccEndpointsService, private httpClient: HttpClient, private router: Router) {}

  searchCustomers(customer: CustomerSearchForm) {
    return this.httpClient.get(this.endPointService.buildUrl(KN_BR_CUSTOMERS, { queryParams: customer })).pipe(
      tap((response: any) => {
        const isEmptyResponse =
          !response ||
          (Array.isArray(response) && response.length === 0) ||
          (typeof response === 'object' && Object.keys(response).length === 0);
        if (isEmptyResponse && !this.hasSearchParams(customer)) {
          this.router.navigateByUrl('/no-b2b-units');
        }
      })
    );
  }

  private hasSearchParams(customer: CustomerSearchForm): boolean {
    if (!customer) {
      return false;
    }
    const { customerName, customerNumber, countryCode, stateCode, city, postalCode } = customer;
    return [customerName, customerNumber, countryCode, stateCode, city, postalCode].some(
      (value) => value !== null && value !== undefined && value !== ''
    );
  }
}
